// Notification push (data.type) → écran, sous-écran et élément à ouvrir.
const ITEM_TYPES = {
  courrier: { screen: 'a-traiter', ecran: 'COURRIER', kind: 'courrier' },
  dossier_medical: { screen: 'a-traiter', ecran: 'DOSSIERS_MED', kind: 'suivi' },
  champ_visuel: { screen: 'champ-visuel', kind: 'cv' },
  chirurgie: { screen: 'a-traiter', ecran: 'CHIRURGIE', kind: 'chirurgie' },
};

export const routeForNotif = (d = {}) => {
  const t = d.type || '';
  switch (t) {
    case 'new_message': return { screen: 'messages', chat: { message_type: d.messageType, sender_id: d.senderId, groupe_id: d.groupeId, groupe_centres_id: d.groupeCentresId, focus: true } };
    case 'tache_invalidee': return { screen: 'taches', kind: 'tache', id: d.tache_id };
    case 'demande_examen': return { screen: 'demandes-examen', kind: 'examen', id: d.demande_id };
    case 'dossier_a_traiter': case 'dossier_traite': case 'retour_direction':
      return { screen: 'a-traiter', ecran: 'COURRIER', kind: 'courrier', id: d.dossier_id };
    case 'courrier_direction': return { screen: 'a-traiter', ecran: 'DIRECTION', kind: 'courrier_direction', id: d.dossier_id };
    case 'message_direction': return { screen: 'a-traiter', ecran: 'DIRECTION', kind: 'direction', id: d.message_id };
    case 'transfert_assistant': case 'retour_medecin': case 'conversation_assistant': {
      const base = ITEM_TYPES[d.item_type] || ITEM_TYPES.courrier;
      return { ...base, id: d.item_id };
    }
    case 'champ_visuel': return { screen: 'champ-visuel', kind: 'cv', id: d.entry_id };
    case 'demande_ipl': return { screen: 'examens-ipl', kind: 'ipl', id: d.entry_id };
    case 'fichier_a_signer': return { screen: 'news', kind: 'fichier', id: d.fichier_id };
    case 'fichier_signe': case 'fichier_signe_complet': return { screen: 'news', kind: 'fichier_gestion', id: d.fichier_id };
    case 'annonce_pinned': return { screen: 'messages', chat: { message_type: 'GENERAL' }, kind: 'annonce', id: d.annonceId };
    case 'coffre_fort_document': return { screen: 'documents', kind: 'document', id: d.document_id };
    case 'fiche_salaire': return { screen: 'documents', kind: 'document', id: d.fiche_id };
    case 'agenda_reminder': return { screen: 'planning', kind: 'agenda', id: d.event_id };
    case 'planning_update': case 'creneau_annule': case 'creneau_supprime': case 'daily_planning':
      return { screen: 'planning', kind: 'planning', id: d.date || d.date_debut || 'jour' };
    case 'colleague_leave': return { screen: 'conges' };
    case 'inscription_request': return { screen: 'centres', kind: 'inscription', id: d.inscription_id };
    case 'securite_alerte': case 'ip_bannie': case 'connexion_signalee': return { screen: 'pare-feu' };
    case 'connexion_hors_zone': return { screen: 'pare-feu', kind: 'connexion', id: d.connexion_id };
    case 'facture_medecin': case 'facture_alerte': return { screen: 'registre', kind: 'facture', id: d.facture_id };
    case 'especes': case 'pot_commun': case 'dette': return { screen: 'especes', kind: t, id: d.item_id };
    default:
      if (t.startsWith('new_demande') || t.startsWith('new_demandes') || t.endsWith('_status')) return { screen: 'demandes-travail' };
      if (d.screen) return { screen: d.screen, ecran: d.ecran || null };
      return null;
  }
};
